/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Delete_ButtonInputs */

const en_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Metadata`)
};

const fr_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la métadonnée`)
};

const de_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten löschen`)
};

const it_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina metadati`)
};

const ru_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление метаданных`)
};

const es_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar metadatos`)
};

const zh_cn2_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除元数据`)
};

const ja_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータの削除`)
};

const hi_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा हटाएं`)
};

const pt_pt2_options_metadata_delete_button = /** @type {(inputs: Options_Metadata_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir metadados`)
};

/**
* | output |
* | --- |
* | "Delete Metadata" |
*
* @param {Options_Metadata_Delete_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_delete_button = /** @type {((inputs?: Options_Metadata_Delete_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Delete_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_delete_button(inputs)
	if (locale === "de") return de_options_metadata_delete_button(inputs)
	if (locale === "it") return it_options_metadata_delete_button(inputs)
	if (locale === "ru") return ru_options_metadata_delete_button(inputs)
	if (locale === "es") return es_options_metadata_delete_button(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_delete_button(inputs)
	if (locale === "ja") return ja_options_metadata_delete_button(inputs)
	if (locale === "hi") return hi_options_metadata_delete_button(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_delete_button(inputs)
	return en_options_metadata_delete_button(inputs)
});